import * as actionTypes from '../actions/types';
export default function translationReducer(state = [], action) {
  switch (action.type) {
    case actionTypes.ADD_TO_TRANSLATION:
      return action.translation;
    default:
      return state;
  }
}